import { BaseResponse } from './internal/baseresponse';
export class PushModifyResult extends BaseResponse {
  data: null;
}



// WEBPACK FOOTER //
// ./src/app/response/pushmodifyresult.ts